import React from "react";
import axios from "axios";

import "../css/Contact.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faUser,
  faPhone,
  faEnvelope,
  faMapMarker,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";

import ReactModal from "react-modal";
const Footer = React.lazy(() => import("./Footer"));

// const path = require('path');
// require('dotenv').config({ path: path.resolve(__dirname, '/.env') });

library.add(faUser, faPhone, faEnvelope, faMapMarker);

class Contact extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   name: "",
    //   phone: "",
    //   email: "",
    //   message: "",
    //   shouldModalOpen: false,
    // };

    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  // handleSubmit(e) {
  //   var apiUrl = process.env.REACT_APP_API_URL;
  //   e.preventDefault();
  //   axios({
  //     method: "POST",
  //     // url: "http://localhost:8081/send",
  //     // url: "https://finelinetherapy.com/send",
  //     url: apiUrl,
  //     data: this.state,
  //   }).then((response) => {
  //     if (response.data.status === "success") {
  //       alert("Message Sent.");
  //       this.resetForm();
  //       console.log("Response");
  //       console.log(response);
  //     } else if (response.data.status === "fail") {
  //       console.log(response);
  //       alert("Message failed to send.");
  //     }
  //   });
  // }

  // handleClick() {
  //   this.state.shouldModalOpen = false;
  // }

  // resetForm() {
  //   this.setState({ name: "", phone: "", email: "", message: "" });
  // }

  render() {
    return (
      <div className="container">
        <h1 className="contact-header">Contact Us</h1>
        <span className="accent"></span>
        <h5 className="contact-txt">
          Give us a call or shoot us an email and we will get back to you as soon as we can!{" "}
        </h5>
        <div className="contact-section">
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1319220.4887612618!2d-87.62030035045353!3d41.744580047265906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1755818582132!5m2!1sen!2sus"
              width="100%"
              height="400"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="google-maps"
            ></iframe>
          </div>

          <ul className="contact-list">
            <li className="list-item">
              <FontAwesomeIcon icon="map-marker" className="icon" />
              <span className="contact-text">
                Serving Chicagoland and Indiana
              </span>
            </li>

            <li className="list-item">
              <FontAwesomeIcon icon="envelope" className="icon" />
              <a
                className="contact-text"
                href="mailto:pedrozavala2005@yahoo.com"
                title="Send me an email"
              >
                Pedrozavala2005@yahoo.com
              </a>
            </li>

                        <li className="list-item">
              <FontAwesomeIcon icon="phone" className="icon" />
              <a
                className="contact-text"
                href="tel:1-773-576-3223"
                title="Give me a call"
              >
                (773) 576-3223
              </a>
            </li>
          </ul>
        </div>

        {/* <ReactModal isOpen={this.state.shouldModalOpen}>
          <p className="contact-modal">Your message has been sent.</p>
          <Button onClick={() => this.handleClick()}>Close</Button>
        </ReactModal> */}

        {/* <footer className="contact-footer">
          <div className="row">
            <div className="col-lg-12">
              <p className="footer-txt">Ingenious Construction</p>
              <p className="footer-txt">&#169;All Rights Reserved 2025</p>
            </div>
          </div>
        </footer> */}
      </div>
    );
  }

  onNameChange(event) {
    this.setState({ name: event.target.value });
  }

  onPhoneChange(event) {
    this.setState({ phone: event.target.value });
  }

  onEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  onMessageChange(event) {
    this.setState({ message: event.target.value });
  }
}

export default Contact;
